module.exports = __webpack_public_path__ + "static/media/back-icon-black.0e49b9d8.svg";